module.exports = __webpack_public_path__ + "static/img/fuhefei.96666db9.svg";